import {
  DateFilter,
  GuidFilter,
  IdFilter,
  StringFilter,
} from "react3l-advanced-filters";
import { ModelFilter } from "react3l-common";

export class StudentFilter extends ModelFilter {
  public id?: IdFilter = new IdFilter();
  public statusId?: IdFilter = new IdFilter();
  public majorId?: IdFilter = new IdFilter();
  public genderId?: IdFilter = new IdFilter();
  public name?: StringFilter = new StringFilter();
  public className?: StringFilter = new StringFilter();
  public cohortId?: IdFilter = new IdFilter();
  public educationTypeId?: IdFilter = new IdFilter();
  public code?: StringFilter = new StringFilter();
  public updatedAt?: DateFilter = new DateFilter();
  public rowId?: GuidFilter = new GuidFilter();
  public search?: string = null;
}
